import type { FC } from 'react'
import React from 'react'
import ReactModal from 'react-modal'

type Props = {
  isOpen: boolean
  children: React.ReactNode
  onRequestClose?: () => void
}

export const Modal: FC<Props> & {
  setAppElement: typeof ReactModal.setAppElement
} = ({ isOpen, children, onRequestClose }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      style={{
        overlay: {},
        content: {},
      }}
      portalClassName="portalClassName"
      overlayClassName="overlayClassName"
      className="className"
      bodyOpenClassName="bodyOpenClassName"
      htmlOpenClassName="htmlOpenClassName"
      onRequestClose={onRequestClose}
    >
      {children}
    </ReactModal>
  )
}

Modal.setAppElement = ReactModal.setAppElement
